import {
  Emoji,
  getTranslatedText,
  useIntl,
  withErrorBoundary
} from '@nile/components';
import '@nile/components/src/Style/ticketDetailsStyles.scss';
import { SVGIcon } from '@superops/super-icons';
import { Badge, Card, TextStyle } from '@superops/ui-design-system';
import React from 'react';
import TicketSLA from '@nile/mangifera/src/Pages/TicketDetails/Components/TicketSLA.js';
import Tippy from '@tippyjs/react';

const TicketToolbarSLA = (props) => {
  const { ticket } = props;
  const intl = useIntl();

  const resolutionViolated = ticket?.resolutionViolated;
  const resolutionTime = ticket?.resolutionTime;
  const resolutionDueTime = ticket?.resolutionDueTime;
  const firstResponseViolated = ticket?.firstResponseViolated;
  const firstResponseTime = ticket?.firstResponseTime;
  const firstResponseDueTime = ticket?.firstResponseDueTime;
  const resolutionPauseTime = ticket?.resolutionPauseTime;

  let svgIcon =
    firstResponseTime || (!firstResponseTime && !firstResponseDueTime)
      ? 'Flag'
      : 'Response';

  let svgIconColor;
  let showPopper;

  if (resolutionViolated || firstResponseViolated) {
    svgIconColor = '#F7C1C1';
    svgIcon = `${svgIcon}Filled`;
  }

  if (resolutionPauseTime) {
    svgIconColor = '#FADCBF';
    svgIcon = `${svgIcon}Filled`;
  }

  if (!resolutionViolated && resolutionTime) {
    showPopper = true;
  }

  const text =
    firstResponseTime || (!firstResponseTime && !firstResponseDueTime)
      ? getTranslatedText(intl, 'kanbanview.actionlist.ticketResolutionTime')
      : getTranslatedText(intl, 'metric.firstResponseTime');

  const getBadgeData = () => {
    if (!firstResponseTime) {
      if (firstResponseViolated) {
        return {
          badgeText: getTranslatedText(intl, 'attribute.overdue'),
          badgeVariant: 'critical'
        };
      }

      if (firstResponseDueTime && !firstResponseViolated) {
        return {
          badgeText: 'Running',
          badgeVariant: 'info'
        };
      }
    }

    if (firstResponseTime || (!firstResponseTime && !firstResponseDueTime)) {
      // if first response time is present we'll check for resolution data
      if (resolutionPauseTime) {
        return {
          badgeText: getTranslatedText(
            intl,
            'ticket.list.resolutionTimer.paused'
          ),
          badgeVariant: 'attention'
        };
      }

      if (resolutionViolated) {
        return {
          badgeText: getTranslatedText(intl, 'attribute.overdue'),
          badgeVariant: 'critical'
        };
      }

      if (!resolutionViolated && resolutionTime) {
        return {
          badgeText: getTranslatedText(
            intl,
            'ticket.list.resolutionTimer.achieved'
          ),
          badgeVariant: 'success'
        };
      }

      if (!resolutionViolated && resolutionDueTime) {
        return {
          badgeText: 'Running',
          badgeVariant: 'info'
        };
      }
    }
  };

  const badgeData = getBadgeData();

  return (
    <Tippy
      content={
        <div className="p20">
          <TicketSLA
            sla={ticket?.sla}
            resolutionViolated={ticket?.resolutionViolated}
            resolutionTime={ticket?.resolutionTime}
            resolutionDueTime={ticket?.resolutionDueTime}
            firstResponseViolated={ticket?.firstResponseViolated}
            firstResponseTime={ticket?.firstResponseTime}
            firstResponseDueTime={ticket?.firstResponseDueTime}
            resolutionPauseTime={ticket?.resolutionPauseTime}
          />
        </div>
      }
      duration={250}
      delay={500}
      interactive
      placement="bottom-start"
      arrow={false}
      allowHTML
      theme="light"
      appendTo={document.body}
    >
      <div className="flex actr g5 fsize12 pointer">
        <div
          className={`flex ${!svgIconColor && !showPopper ? 'opacity5' : ''}`}
        >
          {showPopper ? (
            <Emoji symbol="🎉" label="popper" />
          ) : (
            <SVGIcon name={svgIcon} color={svgIconColor} />
          )}
        </div>

        <div>
          <TextStyle weight="Medium">{text}</TextStyle>
        </div>

        <div>
          <Badge status={badgeData?.badgeVariant}>
            <TextStyle weight="Medium">
              {badgeData?.badgeText || 'NA'}
            </TextStyle>
          </Badge>
        </div>
      </div>
    </Tippy>
  );
};

export default withErrorBoundary(TicketToolbarSLA);
